import React, {useContext, useEffect, useRef} from "react";
import '../../../../global/css/container.css'
import '../../../../global/css/global-display.css'
import '../../../../global/css/font-style.css'
import {PageEnum} from "../../../../types/IPage.ts";
import {ThemeContext} from "../../../../providers/themeContext/theme-context.tsx";
import {useUserContext} from "../../../../providers/userProvider/user-context.tsx";
import CustomPopup from "../../../../components/CustomPopup";
import {GAEvents} from "../../../../common/utils/GA4/GAEvents.ts";
import {ToastContext} from "../../../../components/CustomToast/ToastProvider.tsx";
import {ShareUtil} from "../../../../common/utils/share-util/shareUtil.ts";
import html2canvas from "html2canvas";
import Avatar from "../../../../components/Avatar/Avatar.tsx";
import {UrlConfig} from "../../../../common/config/url-config.ts";

type ChallengeGameFailDialogProps = {
    correctWord?: string;
    isOpen: boolean;
    onClose: () => void;
    switchPage: (page: PageEnum) => void;
    bestStreak: number
};

// daily 游戏失败时的弹窗
const ChallengeGameFailDialog: React.FC<ChallengeGameFailDialogProps> = ({
                                                                             isOpen,
                                                                             onClose,
                                                                             correctWord,
                                                                             switchPage,
                                                                             bestStreak
                                                                         }) => {

    // 主题全局管理器
    const {imgUrls, theme} = useContext(ThemeContext);
    const {addToast} = useContext(ToastContext);
    // 全局用户信息provider
    const {aiLevel, setAiLevel} = useUserContext();
    const targetRef = useRef(null)

    // 跳转到挑战页面
    const jumpToChallengePage = () => {
        // GA埋点
        GAEvents.aiChallengeGameFailPopupChallengeClick();

        setAiLevel(1)
        switchPage(PageEnum.CHALLENGE);
    }
    useEffect(() => {
        if (isOpen) {
            // GA埋点
            GAEvents.aiChallengeGameFailPopupShow();
        }
    }, [isOpen]);

    // useEffect(() => {
    //     // 解决跨域问题
    //     convertOSSImageToBase64("https://ucenter.user.cgtn.com/backend/avatar/C3E1i1Fq.png").then((dataUrl: string) => {
    //         const node = document.getElementById("ai_fail_left_avatar");
    //         if (node) {
    //             // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //             // @ts-expect-error
    //             node.src = dataUrl;
    //         }
    //     })
    // }, []);

    // 对组件截图
    const captureScreenshot = () => {
        // GA埋点
        GAEvents.aiChallengeGameFailPopupShareClick();

        const node = targetRef.current;
        if (node) {
            html2canvas(node, {scale: 2, useCORS: true, allowTaint: false})
                .then((canvas) => {
                    // 获取图片dataUrl
                    const dataUrl = canvas.toDataURL('image/png');
                    ShareUtil.share(new URL(UrlConfig.SHARE_URL), (e) => {
                        addToast({type: "warning", message: `Share error.：${e}`})
                    }, dataUrl)
                })
                .catch((error) => {
                    console.error('Share error.', error);
                });
        }
    };

    return (
        <CustomPopup isOpen={isOpen} onClose={onClose}>
            <div style={theme?.aiGameFailDialogBg ? {
                backgroundImage: `url(${theme?.aiGameFailDialogBg})`,
                backgroundSize: "contain",
                backgroundRepeat: "no-repeat",
            } : {}}
                 ref={targetRef}
                 className={`${theme?.aiGameFailDialogBg ? '' : 'bg-color-white'} width-300 height-405 border-radius-10 display-fixed-center`}>
                {!theme?.dailyGameEndDialogBg &&
                    <img className="common-dialog-embellish-bg-left-top" src={imgUrls.leftTopBgDialogUrl}
                         alt="pic"/>}
                {!theme?.dailyGameEndDialogBg &&
                    <img className="common-dialog-embellish-bg-right-bottom" src={imgUrls.rightBottomBgDialogUrl}
                         alt="pic"/>}
                {/*关闭按钮*/}
                <img className="exit-close-btn" onClick={onClose}
                     src={theme?.aiGameFailDialogCloseBtn ?? imgUrls.closerBtnGreyUrl} alt="pic"/>
                {/*标题*/}
                <div style={{color: theme?.gameDescriptionTextColor}}
                     className="my-roboto-bold margin-top-14 font-size-16 text-center">Try Again!
                </div>
                {/*challenge头像*/}
                <div className="margin-top-30 height-68 display-flex-row">
                    <div
                        className="width-145 height-66 bg-img-cover-no-repeat-center common-position-absolute display-flex-row display-flex-align-items-center display-flex-justify-content-center"
                        style={{
                            backgroundImage: `url(${theme?.aiGameFailDialogLeftAvatarBg ?? imgUrls.challengeFailDialogAvatarLeft})`,
                            backgroundSize: "contain"
                        }}>
                        <Avatar className="height-38 width-38"/>
                        <div className="margin-left-8 margin-right-16 my-roboto-bold font-size-16 color-white">YOU</div>
                    </div>
                    <div
                        className="width-183 margin-left-auto position-left-auto  height-66 bg-img-cover-no-repeat-center common-position-absolute right-0 display-flex-row display-flex-align-items-center display-flex-justify-content-center"
                        style={{
                            backgroundImage: `url(${theme?.aiGameFailDialogRightAvatarBg ?? imgUrls.challengeFailDialogAvatarRight})`,
                            backgroundSize: "cover"
                        }}>
                        <img className="height-40 width-40 margin-left-20" src={imgUrls.aiAvatarUrl} alt="pic"/>
                        <div className="margin-left-8 my-roboto-bold font-size-16 color-white">AI WIN!</div>
                    </div>
                </div>
                {/*正确单词框*/}
                <div
                    style={{backgroundImage: `url(${theme?.aiGameFailDialogCardBg ?? imgUrls.aiChallengeDialogCardBgUrl})`}}
                    className="margin-top-20 padding-top-20 padding-bottom-20 width-273 height-142 margin-left-right-auto border-radius-10 game-fail-word-box margin-top-6 display-flex-column display-flex-justify-content-center display-flex-align-items-center">
                    <div style={{color: theme?.gameDescriptionTextColor}}
                         className="font-size-16 color-grey my-roboto-regular">Answer
                    </div>
                    <div className="grid-5-columns grid-gap-3 margin-top-14">
                        {correctWord?.toUpperCase().split("").map((letter, index) => {
                            return (
                                <div key={letter + index}
                                     style={theme?.GameEndDialogLetterBg ? {
                                         backgroundImage: `url(${theme?.GameEndDialogLetterBg})`,
                                         backgroundSize: 'cover'
                                     } : {}}
                                     className="display-flex-column display-flex-align-items-center display-flex-justify-content-center border-radius-4 width-33 height-40 bg-color-liner-white-green">
                                    <div className="font-size-27 color-white my-roboto-bold ">{letter}</div>
                                </div>
                            );
                        })}
                    </div>
                    <div style={{color: theme?.gameDescriptionTextColor}}
                         className="display-flex-column display-flex-align-items-center display-flex-justify-content-center">
                        <div className="margin-top-14 font-size-16 my-roboto-regular">Current
                            Streak: {aiLevel - 1}</div>
                        {/*个人initInfo里的数据level_wins。如果当前的level大于这个，就显示level*/}
                        <div className="margin-top-14 font-size-16 my-roboto-regular">Best
                            Streak: {bestStreak}</div>
                    </div>
                </div>
                {/*按钮部分*/}
                <div
                    className="margin-top-16 height-43 display-flex-row width-273 display-flex-justify-content-center display-flex-align-items-center display-flex-align-content margin-left-right-auto">
                    {/*分享按钮*/}
                    <div onClick={captureScreenshot}
                         className={`${theme?.aiGameFailDialogShareBtn ? '' : 'bg-color-liner-green-blue'} height-43 width-43 border-radius-5 display-flex-column display-flex-align-items-center display-flex-justify-content-center`}>
                        {theme?.aiGameFailDialogShareBtn ?
                            <img className="height-43 width-43 bg-img-cover-no-repeat-center"
                                 src={theme?.aiGameFailDialogShareBtn} alt="pic"/>
                            :
                            <img className="width-18 height-18" src={imgUrls.shareIconBlueUrl} alt="pic"/>}
                    </div>
                    {/*挑战按钮*/}
                    <div onClick={jumpToChallengePage}
                         style={theme?.dailyGameEndDialogChallengeBtnBg ? {
                             backgroundImage: `url(${theme?.dailyGameEndDialogChallengeBtnBg})`,
                             backgroundSize: "cover"
                         } : {}}
                         className={`${theme?.dailyGameEndDialogChallengeBtnBg ? '' : 'bg-color-liner-green-challenge'} margin-left-8 width-222 height-43 border-radius-5 display-flex-column display-flex-justify-content-center display-flex-align-items-center`}>
                        <div className="font-size-16 my-roboto-medium color-white">Challenge</div>
                    </div>
                </div>
            </div>
        </CustomPopup>
    );
}
export default ChallengeGameFailDialog;